<template>
  <!-- mcf-light/mcf-dark 切換日夜模式-->
  <div :class="layoutType" class="h-100 d-flex flex-column">
    <div>
      <slot name="header"></slot>
    </div>
    <div
      class="flex-grow-1 mcf-bg h-100"
      :class="(isWriteOffClick || isTransfer) ? 'overflow-hidden' : 'overflow-y'"
      ref="scrollContainer"
    >
      <slot name="content"></slot>
    </div>
    <div class="position-sticky" style="bottom: 0">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      backgroundPic: '',
    };
  },
  computed: {
    ...mapState(['layoutType']),
    ...mapState('memberSource', [
      'isWriteOffClick',
      'isTransfer']),
  },
  created() {
    const vm = this;
    vm.$store
      .dispatch('getPageSetting', 'MemberCentreHomePage')
      .then((setting) => {
        vm.backgroundPic = setting.backgroundMobilePic;
      });
  },
};
</script>
